/**
 * Onboarding mutation key factory (auth user lives in AuthContext, not React Query reads).
 */
export const onboardingQueryKeys = {
  all: ['onboarding'] as const,
  businessDetails: () => [...onboardingQueryKeys.all, 'business-details'] as const,
  businessInfo: () => [...onboardingQueryKeys.all, 'business-info'] as const,
  extractBrand: () => [...onboardingQueryKeys.all, 'extract-brand'] as const,
  applyBrand: () => [...onboardingQueryKeys.all, 'apply-brand'] as const,
  extractOfferings: () => [...onboardingQueryKeys.all, 'extract-offerings'] as const,
  extractContactForm: () => [...onboardingQueryKeys.all, 'extract-contact-form'] as const,
};
